import IconFacebook from "../_components/utils/badge-rounded-square/icons-svg/IconFacebook";
import IconInstagram from "../_components/utils/badge-rounded-square/icons-svg/IconInstagram";
import IconLinkedIn from "../_components/utils/badge-rounded-square/icons-svg/IconLinkedIn";
import IconTwitter from "../_components/utils/badge-rounded-square/icons-svg/IconTwitter";

export function formatDate(dateStr: string): string {
	const date = new Date(dateStr);
	const options: Intl.DateTimeFormatOptions = {
		month: "short",
		day: "2-digit",
		year: "numeric",
	};
	// Ustawienie en-US da Ci skrócone nazwy miesięcy jak "JUL"
	return date.toLocaleDateString("en-US", options).toUpperCase();
}

export function getIconForSocialMedia(name: string) {
	const lowerName = name.toLowerCase();
	if (lowerName.includes("instagram")) return <IconInstagram />;
	if (lowerName.includes("linkedin")) return <IconLinkedIn />;
	if (lowerName.includes("facebook")) return <IconFacebook />;
	if (lowerName.includes("twitter") || lowerName.includes("x")) return <IconTwitter />;
	return null;
}

export function getAspectRatioFromSanityRefRaw(ref: string): string | null {
	if (!ref) return null;

	const match = ref.match(/-(\d+)x(\d+)-/);
	if (!match) return null;

	const width = match[1];
	const height = match[2];

	return `${width} / ${height}`;
}
